export enum IMAGE_UPLOAD_STATUS {
  INIT = 'INIT',
  UPLOADING = 'UPLOADING',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  UPLOADED = 'UPLOADED',
}
export interface ImageUploadResponse {
  name: string
  status: string
  url: string
  thumbUrl: string
}

export default interface Photo {
  id: string
  lineItemId: string
  name: string
  value: string
  imageUploadResponse?: ImageUploadResponse
  file: File
  imageUploadStatus: IMAGE_UPLOAD_STATUS
}
